import { get, put } from "../../../core/api/client";
import { API_ENDPOINTS } from "../../../core/api/endpoints";

const toClientUpdatePayload = (client, overrides = {}) => ({
  client_name: client.client_name,
  plan_id: client.plan_id,
  client_category: client.client_category,
  client_email: client.client_email,
  client_address: client.client_address,
  client_phone: client.client_phone,
  timezone: client.timezone,
  client_status: client.client_status,
  delivery_failure_notification: client.delivery_failure_notification,
  usage_alert_notification: client.usage_alert_notification,
  system_alert_notification: client.system_alert_notification,
  ...overrides,
});

export const getClientNotificationSettings = async (clientId) => {
  const response = await get(API_ENDPOINTS.CLIENTS.LIST);

  if (response?.error) {
    return response;
  }

  const clients = Array.isArray(response?.clients) ? response.clients : [];
  const targetClient =
    clients.find((item) => Number(item.id) === Number(clientId));

  if (!targetClient) {
    return { error: { message: "No client records found." } };
  }

  return {
    client: targetClient,
  };
};

export const updateClientNotificationSettings = async (
  client,
  updates,
) => {
  if (!client?.id) {
    return { error: { message: "Client id is required to update settings." } };
  }

  const payload = toClientUpdatePayload(client, updates);
  const response = await put(API_ENDPOINTS.CLIENTS.UPDATE(client.id), payload);

  if (response?.error) {
    return response;
  }

  return {
    ...response,
    client: {
      ...client,
      ...updates,
    },
  };
};
